(function () {
  'use strict';

  var frameDescriptions = {
    square: 'square 1:1 composition',
    portrait: 'portrait 4:5 composition, leaving room around the full ears and visible paws',
    wrap12x16: 'portrait 4:5 full artwork representing 16 × 20 inches overall, with a central 12 × 16-inch front and 2 inches of allowance on every edge for this worked 1-inch-depth example. The left and right margins are 12.5% each; the top and bottom margins are 10% each. Keep the entire head, ears, paws and important text comfortably INSIDE the central front. Only continuing background belongs in the outer allowance. No printed guides, lines or dimensions.',
    wrap16x20: 'portrait 5:6 full artwork representing 20 × 24 inches overall, with a central 16 × 20-inch front and 2 inches of allowance on every edge for this worked 1-inch-depth example. The left and right margins are 10% each; the top and bottom margins are approximately 8.33% each. Keep the entire head, ears, paws and important text comfortably INSIDE the central front. Only continuing background belongs in the outer allowance. No printed guides, lines or dimensions.',
    wrap12square: 'square 1:1 full artwork representing 16 × 16 inches overall, with a central 12 × 12-inch front and 2 inches of allowance on every edge for this worked 1-inch-depth example. Each outer margin is 12.5%. Keep the entire head, ears, paws and important text comfortably INSIDE the central front. Only continuing background belongs in the outer allowance. No printed guides, lines or dimensions.',
    wrap16square: 'square 1:1 full artwork representing 20 × 20 inches overall, with a central 16 × 16-inch front and 2 inches of allowance on every edge for this worked 1-inch-depth example. Each outer margin is 10%. Keep the entire head, ears, paws and important text comfortably INSIDE the central front. Only continuing background belongs in the outer allowance. No printed guides, lines or dimensions.'
  };

  function initialiseGuide(root) {
    if (root.hasAttribute('data-ypg-prompts-ready')) return;

    var configElement = root.querySelector('[data-prompt-config]');
    if (!configElement) return;

    var configs;
    try {
      configs = JSON.parse(configElement.textContent);
    } catch (error) {
      return;
    }
    if (!Array.isArray(configs)) return;

    var byId = new Map();
    configs.forEach(function (config) {
      if (config && typeof config.id === 'string' && typeof config.template === 'string') {
        byId.set(config.id, config);
      }
    });

    var petName = root.querySelector('[data-pet-name]');
    var petFeatures = root.querySelector('[data-pet-features]');
    root.setAttribute('data-ypg-prompts-ready', 'true');

    root.querySelectorAll('.ypg-prompt[data-example]').forEach(function (card) {
      var config = byId.get(card.getAttribute('data-example'));
      var textarea = card.querySelector('[data-prompt]');
      if (!config || !textarea) return;

      var colours = card.querySelector('[data-colours]');
      var award = card.querySelector('[data-award]');
      var frame = card.querySelector('[data-frame]');
      var customFields = card.querySelectorAll('[data-prompt-field]');
      var status = card.querySelector('[data-copy-status]');
      var defaults = config.defaults && typeof config.defaults === 'object' ? config.defaults : {};

      function valueOf(field, fallback) {
        var value = field && typeof field.value === 'string' ? field.value.trim() : '';
        return value || fallback || '';
      }

      function say(message) {
        if (status) status.textContent = message;
      }

      function rebuild() {
        var frameValue = frame ? frame.value : 'square';
        var frameDescription = Object.prototype.hasOwnProperty.call(frameDescriptions, frameValue)
          ? frameDescriptions[frameValue]
          : frameDescriptions.square;
        var replacements = {
          NAME: valueOf(petName, 'my pet'),
          FEATURES: valueOf(petFeatures, 'the pet in my attached photograph').replace(/[.!?]+$/, ''),
          COLOURS: valueOf(colours, typeof defaults.colours === 'string' ? defaults.colours : ''),
          AWARD: valueOf(award, typeof defaults.award === 'string' ? defaults.award : ''),
          FRAME: frameDescription
        };
        customFields.forEach(function (field) {
          var key = field.getAttribute('data-prompt-field');
          if (/^[A-Z_]+$/.test(key || '')) {
            replacements[key] = valueOf(field, typeof defaults[key.toLowerCase()] === 'string' ? defaults[key.toLowerCase()] : '');
          }
        });
        textarea.value = config.template.replace(/\{\{([A-Z_]+)\}\}/g, function (match, key) {
          return Object.prototype.hasOwnProperty.call(replacements, key) ? replacements[key] : match;
        });
      }

      function selectPrompt() {
        try {
          textarea.focus({ preventScroll: true });
        } catch (error) {
          textarea.focus();
        }
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
      }

      async function copyPrompt(button) {
        var text = textarea.value;
        if (!text.trim()) {
          say('The prompt is empty. Apply your choices or write your prompt first.');
          return;
        }

        var wasDisabled = button.disabled;
        button.disabled = true;
        var copied = false;
        try {
          if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            try {
              await navigator.clipboard.writeText(text);
              copied = true;
            } catch (error) {
              // Local previews and some browsers need the selection fallback.
            }
          }

          if (!copied) {
            selectPrompt();
            try {
              copied = typeof document.execCommand === 'function' && document.execCommand('copy');
            } catch (error) {
              copied = false;
            }
          }

          if (copied) {
            say('Copied. Paste into your image editor with your pet photograph attached.');
          } else {
            selectPrompt();
            say('Your prompt is selected. Use your device’s Copy command, then paste it into your image editor.');
          }
        } finally {
          button.disabled = wasDisabled;
        }
        if (copied && !wasDisabled) {
          try {
            button.focus({ preventScroll: true });
          } catch (error) {
            button.focus();
          }
        }
      }

      var buildButton = card.querySelector('[data-build]');
      if (buildButton) {
        buildButton.addEventListener('click', function (event) {
          event.preventDefault();
          rebuild();
          say('Prompt updated. You can edit the full wording below before copying.');
        });
      }

      var copyButton = card.querySelector('[data-copy]');
      if (copyButton) {
        copyButton.addEventListener('click', function (event) {
          event.preventDefault();
          copyPrompt(copyButton);
        });
      }

      var resetButton = card.querySelector('[data-reset]');
      if (resetButton) {
        resetButton.addEventListener('click', function (event) {
          event.preventDefault();
          if (colours) colours.value = typeof defaults.colours === 'string' ? defaults.colours : '';
          if (award) award.value = typeof defaults.award === 'string' ? defaults.award : '';
          customFields.forEach(function (field) {
            var key = (field.getAttribute('data-prompt-field') || '').toLowerCase();
            field.value = typeof defaults[key] === 'string' ? defaults[key] : '';
          });
          if (frame) frame.value = 'square';
          rebuild();
          say('Example reset, using your current pet name and description.');
        });
      }
    });

    var ideasElement = root.querySelector('[data-idea-config]');
    var ideaBuilder = root.querySelector('.ypg-prompt[data-example="own-idea"]');
    var ideas = [];
    try {
      ideas = ideasElement ? JSON.parse(ideasElement.textContent) : [];
    } catch (error) {
      ideas = [];
    }
    if (ideaBuilder && Array.isArray(ideas)) {
      root.querySelectorAll('[data-idea-pick]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var index = Number(button.getAttribute('data-idea-pick'));
          if (!Number.isInteger(index) || index < 0 || !ideas[index]) return;
          var idea = ideas[index];
          ['IDEA', 'SCENE', 'STYLE', 'CAPTION'].forEach(function (key) {
            var field = ideaBuilder.querySelector('[data-prompt-field="' + key + '"]');
            var value = idea[key.toLowerCase()];
            if (field && typeof value === 'string') field.value = value;
          });
          ideaBuilder.open = true;
          var status = ideaBuilder.querySelector('[data-copy-status]');
          if (status) status.textContent = 'Selected: ' + idea.title + '. Your current prompt is unchanged. Choose Apply choices to use this idea.';
          var build = ideaBuilder.querySelector('[data-build]');
          if (build) {
            try { build.focus({ preventScroll: true }); } catch (error) { build.focus(); }
          }
          ideaBuilder.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }
  }

  function initialiseWithin(scope) {
    if (!scope || typeof scope.querySelectorAll !== 'function') return;
    if (typeof scope.matches === 'function' && scope.matches('.yi2c-pet-guide')) {
      initialiseGuide(scope);
    }
    scope.querySelectorAll('.yi2c-pet-guide').forEach(initialiseGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseWithin(document);
    }, { once: true });
  } else {
    initialiseWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseWithin(event.target);
  });
}());
